module.exports = __webpack_public_path__ + "static/img/videobg.2322b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/videobg.jpg
// module id = Eo1Z
// module chunks = 1